import ConfidentialInfo from "./ConfidentialInfo";

export default ConfidentialInfo;
